
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import dynamic from 'next/dynamic';
import React from 'react';
import { LoaderScreen } from '@/components/elements/LoaderScreen';
import { LandingLayout } from '@/components/layouts/LandingLayout';
import { TranslationProvider } from '@/context/translation';
import { createNonLocalizedPageGetServerSidePropsWithTranslations, type NonLocalizedPageWithTranslationsProps, } from '@/helpers/createNonLocalizedPageGetServerSideProps';
const ApparelPhotographyLanding = dynamic(async () => await import('@/templates/Landing/ApparelPhotography/ApparelPhotographyLanding'), {
    loading: LoaderScreen,
});
const index: React.FC<NonLocalizedPageWithTranslationsProps> = ({ locale, translations, }) => {
    return (<TranslationProvider locale={locale} translations={translations}>
			<LandingLayout title='Effortless Apparel Photography for E-Commerce | Lift AI Tools' description='Boost your e-commerce success with high-quality apparel photography powered by AI. Easily create marketplace-ready images with clean backgrounds, enhanced details, and professional consistency — no complex editing needed.' ogTitle='Create Stunning Apparel Product Photos with Lift’s AI' ogDescription='Discover how Lift’s AI tools help you create stunning apparel product photos for Amazon, eBay, Etsy, and more. Remove backgrounds, enhance images, and list products faster with polished, professional visuals.'>
				<ApparelPhotographyLanding />
			</LandingLayout>
		</TranslationProvider>);
};
export default index;
const getServerSideProps = createNonLocalizedPageGetServerSidePropsWithTranslations('/for-businesses/apparel-photography', 'apparel-photography');

    async function __Next_Translate__getServerSideProps__1a1a20bb8a0__(ctx) {
      const res = await getServerSideProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/for-businesses/apparel-photography/index',
            loaderName: 'getServerSideProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getServerSideProps__1a1a20bb8a0__ as getServerSideProps }
  